export const CLEANING_IMAGES = [
  'https://i.postimg.cc/PJ7RNwg4/Whats-App-Image-2026-05-20-at-13-05-14.jpg',
  'https://i.postimg.cc/PJ7RNwgz/Whats-App-Image-2026-05-20-at-13-05-14-(1).jpg',
  'https://i.postimg.cc/90knz76P/Whats-App-Image-2026-05-20-at-13-05-14-(2).jpg',
  'https://i.postimg.cc/Gtf59yWG/Whats-App-Image-2026-05-20-at-13-05-15.jpg',
  'https://i.postimg.cc/5yrRjChv/Whats-App-Image-2026-05-20-at-13-05-15-(1).jpg',
  'https://i.postimg.cc/Fz6B1LMS/Whats-App-Image-2026-05-20-at-13-05-15-(2).jpg',
  'https://i.postimg.cc/SRPvjMBX/Whats-App-Image-2026-05-20-at-13-05-16.jpg',
  'https://i.postimg.cc/1Xdj4qkf/Whats-App-Image-2026-05-20-at-13-05-16-(1).jpg',
  'https://i.postimg.cc/prS6yFwy/Whats-App-Image-2026-05-20-at-13-05-16-(2).jpg',
  'https://i.postimg.cc/tJcM7xKJ/Whats-App-Image-2026-05-20-at-13-05-17.jpg',
  'https://i.postimg.cc/BbzVtKrv/Whats-App-Image-2026-05-20-at-13-05-17-(1).jpg',
  'https://i.postimg.cc/BbzVtKrn/Whats-App-Image-2026-05-20-at-13-05-17-(2).jpg',
  'https://i.postimg.cc/Y0PsjW5q/Whats-App-Image-2026-05-20-at-13-05-18.jpg',
  'https://i.postimg.cc/PJ7RNwgf/Whats-App-Image-2026-05-20-at-13-05-18-(1).jpg',
  'https://i.postimg.cc/yxGbWZM7/Whats-App-Image-2026-05-20-at-13-05-18-(2).jpg',
  'https://i.postimg.cc/nrWPMDyZ/Whats-App-Image-2026-05-20-at-13-05-19.jpg',
  'https://i.postimg.cc/gjj7YDTr/Whats-App-Image-2026-05-20-at-13-05-19-(1).jpg',
  'https://i.postimg.cc/rssH8JPp/Whats-App-Image-2026-05-20-at-13-05-19-(2).jpg',
  'https://i.postimg.cc/fyyPwKrR/Whats-App-Image-2026-05-20-at-13-05-20.jpg',
  'https://i.postimg.cc/2yytzwKj/Whats-App-Image-2026-05-20-at-13-05-20-(1).jpg',
  'https://i.postimg.cc/7hhRxVWH/Whats-App-Image-2026-05-20-at-13-05-20-(2).jpg',
  'https://i.postimg.cc/tJJcX5M9/Whats-App-Image-2026-05-20-at-13-05-21.jpg',
]

export const HERO_IMAGE = CLEANING_IMAGES[0]
export const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/nE6ZRM79Xjtv1YtKG8hJ8d/WhatsApp_Image_2026-05-20_at_12.44.23.jpg'
export const WHATSAPP_URL = 'https://wa.me/19084764884'
export const SMS_URL = 'sms:+19084764884'
export const PHONE_DISPLAY = '(908) 476-4884'
